
import { ref, watch } from 'vue'
import { IdfInput, IdfStandardInputs, IdfTextIcon } from '@invivodf/ui-kit'
import { useSearchDiscountables } from '../../composables/association/useSearchDiscountables'

export default {
  name: 'CAssociationsInputsHeader',
  components: { IdfTextIcon, IdfInput, IdfStandardInputs },
  props: {
    message: {
      type: String,
      default: null,
    },
  },
  setup() {
    const query = ref('')

    let timeout

    const { changeWord } = useSearchDiscountables()

    watch(query, () => {
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        changeWord(query.value)
      }, 500)
    })

    return {
      CSVFile: ref(''),
      query,
    }
  },
}
